let current = '';

export function setSupportSession(id) {
  current = id ? String(id) : '';
}

export function getSupportSession() {
  return current;
}

export function supportSessionHeader() {
  if (!current) return {};
  return { 'x-pacarion-support-session': current };
}
